import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { forEach } from 'lodash-es';


@Component({})
export default class FormulaComponent extends ABaseComponent {

    recaptchaResponse: string = '';
    sendingForm: boolean = false;
    created() {
        // For more options see below
        Vue.use(VueReCaptcha, { siteKey: '6Lf7fq4UAAAAAF7IVnYRTNR73keHsLKQAqJR477A' });

    }
    recaptcha(formId: string, id: string) {
        this.$recaptcha(id).then((token) => {
            this.recaptchaResponse = token;
            // Hack to submit form
            Vue.nextTick(() => {
                var myForm = <HTMLFormElement>document.getElementById(formId);

                //check if there are any empty required fields"submit-confirmation"
                if (this.checkRequired(<HTMLCollectionOf<HTMLInputElement>>myForm.getElementsByClassName("form-control required"))) {
                    //Reset form and notify that the form was sent
                    (<any>myForm).onsubmit();
                    myForm.submit(); 
                    myForm.reset();
                    this.sendingForm = true;
                }
                else {
                    return;
                }
            });
        });
    }

    checkRequired(fieldsList: HTMLCollectionOf<HTMLInputElement>): boolean {
        for (var i in fieldsList) {
            if (fieldsList[i].classList && (fieldsList[i].classList.contains("required"))) {
                //show warning
                if (document.getElementById(fieldsList[i].id + "-warning")) {
                    document.getElementById(fieldsList[i].id + "-warning").hidden = !(fieldsList[i].value === "");
                }
                if (fieldsList[i].value === "") {
                    return false;
                }
            }
        }
        return true;
    }
    hideWarning(elementId : any) {
    }
}
Vue.component('formula', FormulaComponent);